import React from "react"
import kebabCase from "lodash/kebabCase"
import { Link } from "gatsby"
import { useTranslation } from "gatsby-plugin-react-i18next"


import { Text } from "../../Text/Text"
import { fullStateNames } from "../full-state-names"

interface OwnProps {
  location: string;
  supportedLocalities: {
    city: string;
    state: string;
  }[];
}

export type LocalitiesServedByLocationProps = OwnProps

export const LocalitiesServedByLocation: React.FC<LocalitiesServedByLocationProps> = ({
  location,
  supportedLocalities
}) => {
  const { t } = useTranslation("shared", {
    keyPrefix: "location_pages.localities_served",
  });

  return (
    <div className="bg-light-wool">
      <div className="max-w-content-width mx-auto px-5 py-8 md:py-16">
        <div className="mt-5 md:mt-7">
          <Text variant="large-header">{t("title")}</Text>
        </div>
        <div className="mt-5 md:mt-7">
          <Text variant="body">{t("intro", { location })}</Text>
        </div>
        {supportedLocalities.map((region, index) => {
          const state = region[0]
          const localitiesInAState = region[1];
          const fullStateName = fullStateNames[state] || state;

          return (
            <div className="mt-7" key={index}>
              <Text variant="small-subheader">
                {fullStateName}
              </Text>
              {localitiesInAState.map((locality, index) => {
                const {
                  city
                } = locality;
                const slugifiedCityState = kebabCase(`${city}-${state}`)
                return (
                  <span className="[&_a]:underline [&_a]:hover:underline [&_a]:focus:underline md:[&_a]:no-underline">
                    <Text as="span" variant="body">
                      {index !== 0 &&  ", "}
                      <Link key={index} to={`/plasma-donation-near/${slugifiedCityState}`}>
                        {city}
                      </Link>
                    </Text>
                  </span>
                )
              })}
            </div>
          )
        })}
      </div>
    </div>
  )
}
